export default {
  body: {
    desktop: {
      maxWidth: '144rem',
    },
    tablet: {
      maxWidth: '120rem'
    }
  },
  media: {
    desktop: {
      maxWidth: '1440px',
    },
    tablet: {
      maxWidth: '1200px',
      endMaxWidth: '1281px',
    },
    smallTablet: {
      maxWidth: '960px',
    },
    mobile: {
      maxWidth: '600px',
    },
  },
  header: {
    desktop: {
      height: '8rem',
    },
    mobile: {
      height: '7rem',
    },
  },
  footer: {
    desktop: {
      height: '22rem',
    },
  },
  constants: {
    desktop: {
      minWidth: '98rem',
    },
    tablet: {
      minWidth: '30rem',
    },
  },
}
